import type { Datalayer } from '../third-party-tracking/tag-commander/types';
import type {
  ErrorDetails,
  ExtendedError,
  TrackErrorParams,
} from '../third-party-tracking/utils/types';
import { post } from '../utils/httpRequest';

const RUNTIME_ERROR_TRACKS_URL =
  '/frontend-api/javascript-error-tracks/runtime-error-tracks';

export const extractErrorDetails = (error: ExtendedError): ErrorDetails => {
  const { message, fileName, lineNumber, columnNumber, stack } = error || {};
  const details: ErrorDetails = {
    errorMessage: message || 'Unknown error',
    fileName: fileName || 'Unknown file',
    ...(lineNumber && { line: lineNumber }),
    ...(columnNumber && { column: columnNumber }),
    errorStackTrace: stack || 'No stack trace available',
  };

  if (details.errorStackTrace) {
    const stackLines = details.errorStackTrace.split('\n');
    const lineRegex = /at\s(.+) \((.+):(\d+):(\d+)\)/;
    const match = lineRegex.exec(stackLines[1]);

    if (match) {
      details.fileName = match[2];
      details.line = parseInt(match[3], 10) || 0;
      details.column = parseInt(match[4], 10) || 0;
    }
  }

  return details;
};

export const getFrontVersion = (): string => {
  try {
    return (window.tc_vars as Partial<Datalayer>)?.of_version || 'NOT_DEFINED';
  } catch (_e) {
    return 'NOT_DEFINED';
  }
};

export const trackError = async (
  error: ExtendedError,
  boundaryName: string
) => {
  const errorDetails: ErrorDetails = extractErrorDetails(error);
  const params: TrackErrorParams = {
    ...errorDetails,
    blockableFlow: false,
    npmModule: 'frontend-tracking-agent',
    boundaryName,
    href: 'frontend-tracking-agent',
    pageName: 'frontend-tracking-agent',
    frontVersion: getFrontVersion(),
  };
  try {
    await post(RUNTIME_ERROR_TRACKS_URL, params);
  } catch (_e) {
    /**/
  }
};
